import React from 'react';
import Button from '@mui/material/Button';
import { useStringsContext } from '../../../contexts/strings';

interface Props {
  accept: () => void;
  dismiss: () => void;
}

function SnackbarMenuAction({ accept, dismiss }: Props) {
  const { strings } = useStringsContext();
  return (
    <>
      <Button onClick={() => accept()}>{strings.actions.yes}</Button>
      <Button onClick={() => dismiss()}>{strings.actions.no}</Button>
    </>
  );
}

export default SnackbarMenuAction;
